import { GetterTree } from 'vuex'
import { State } from './state'
import { ProductAggregatedStatPobraniaSum } from "@/store/modules/statsPobrania/types";


export function aggregatedStatsPobraniaSumUpdating (state: State): boolean {
    return state.aggregatedStatsPobraniaSumUpdating;
}

export function aggregatedStatsPobraniaSum (state: State): Array<ProductAggregatedStatPobraniaSum> {
    return state.aggregatedStatsPobraniaSum;
}

export function aggregatedStatsPobraniaLoading (state: State): boolean {
    return state.aggregatedStatsPobraniaLoading;
}

export function aggregatedStatsPobrania (state: State): Array<object> {
    return state.aggregatedStatsPobrania;
}

export function aggregatedStatsPobraniaTotal (state: State): number {
    return state.aggregatedStatsPobraniaTotal;
}

export function detailedStatsPobraniaLoading (state: State): boolean {
    return state.detailedStatsPobraniaLoading;
}

export function detailedStatsPobrania (state: State): Array<object> {
    return state.detailedStatsPobrania;
}

export default <GetterTree<State, any>> {
    aggregatedStatsPobraniaSumUpdating,
    aggregatedStatsPobraniaSum,
    aggregatedStatsPobraniaLoading,
    aggregatedStatsPobrania,
    aggregatedStatsPobraniaTotal,
    detailedStatsPobraniaLoading,
    detailedStatsPobrania
}
